import { mainConstants } from '../../constants'

const initialState = {
  isLoading: false,
  isFailure: false,
  appAccessResult: null,
}

export default function setting(state = initialState, action) {
  switch (action.type) {
    /*********
     자동로그인 여부 불러오기
    **********/

    case mainConstants.MAIN_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case mainConstants.MAIN_LOAD_SUCCESS:
      let data = action.response.data.payload

      return {
        ...state,
        settingInfo: data,
      }
    case mainConstants.MAIN_LOAD_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
      }

    /********************
      디바이스 아이디 없으면 insert
    ********************/
    case mainConstants.APP_ACCESS_LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case mainConstants.APP_ACCESS_LOAD_SUCCESS:
      return {
        ...state,
        appAccessResult: action.response.data?.payload,
      }
    case mainConstants.APP_ACCESS_LOAD_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
      }

    default:
      return state
  }
}
